module.exports = __webpack_public_path__ + "static/media/unlv.57567bad.png";